import * as api from '../../../api';

const checkResponse = request =>
    request.then(response => {
        if (response.error) {
            throw new Error(response.error);
        }
        return typeof response.data !== 'undefined' ? response.data : response;
    });

export const initVerify2FA = ({ type, phone, confirmCode }) =>
    checkResponse(
        api.patch('/api/account/2step/setup', {
            type,
            phone,
            confirm_code: confirmCode,
        })
    );

export const verify2FA = ({ code, confirmCode }) =>
    checkResponse(
        api.post('/api/account/2step/setup', {
            code,
            confirm_code: confirmCode,
        })
    );

export const updateBackupPhone = ({ phone, confirmCode }) =>
    checkResponse(
        api.patch('/api/account/2step/setup', {
            phone,
            type: 'backup_phone',
            confirm_code: confirmCode,
        })
    );

export const loadConfig = () =>
    checkResponse(api.get('/api/account/2step/setup'));

export const disable2FA = ({ confirmCode }) =>
    checkResponse(
        api.patch('/api/account/2step/setup', {
            type: 'disable',
            confirm_code: confirmCode,
        })
    );

export const loadRecoveryCodes = ({ confirmCode }) =>
    checkResponse(
        api.get(
            `/api/account/2step/setup?type=recovery_codes&confirm_code=${confirmCode}`
        )
    );

export const generateRecoveryCodes = ({ confirmCode }) =>
    checkResponse(
        api.patch('/api/account/2step/setup', {
            type: 'generate_recovery_codes',
            confirm_code: confirmCode,
        })
    );
